export default __webpack_public_path__ + "static/media/creativite.d8379833.jpg";